import React from 'react';
import { config } from 'codemash';
import { Routes, Route } from 'react-router-dom';
import { Config as ProjectConfig } from './configs';

import './localization';
import { initTableOnLoad } from './services/tableService';
import ServerEventsHandler, { sseHandler } from './services/serverEventsHandler';

import ScrollToTop from './components/misc/scrollToTop';

import { Provider as RestaurantProvider } from './context/restaurant';
import { Provider as CheckoutProvider } from './context/checkout';
import { Provider as AlertProvider } from './context/alert';
import { Provider as AuthProvider } from './context/auth';
import { Provider as CartProvider } from './context/cart';
import { Provider as SettingsProvider } from './context/settings';
import { Provider as DeliveryProvider } from './context/delivery';

import NotFoundPage from './pages/noPage';

// order in place
import HomePage from './pages/main';
import MenuPage from './pages/menu';
import CheckoutPage from './pages/checkout';
import CheckoutTipsPage from './pages/checkoutTips';
import PaymentPage from './pages/payment';
import InitPage from './pages/init';
import CartPage from './pages/cart';
import BillPage from './pages/bill';
import OrderPage from './pages/order';
import OrdersPage from './pages/orders';
import ServiceUnavailablePage from './pages/serviceUnavailable';

// delivery
import RestaurantSelectPage from './pages/delivery/restaurantSelect';
import MenuDeliveryPage from './pages/delivery/menuDelivery';
import CheckoutDeliveryPage from './pages/delivery/checkoutDelivery';
import PaymentDeliveryPage from './pages/delivery/paymentDelivery';

import { createExternalNavigation } from './services/navigationService';

config.init(
  {
    secretKey: ProjectConfig.CODEMASH.SECRET_KEY,
    projectId: ProjectConfig.CODEMASH.PROJECT_ID,
  },
  process.env.NODE_ENV,
);

const App = () => {
  initTableOnLoad();
  createExternalNavigation();

  sseHandler.handler = new ServerEventsHandler();

  return (
    <SettingsProvider>
      <AlertProvider>
        <AuthProvider>
          <DeliveryProvider>
            <RestaurantProvider>
              <CheckoutProvider>
                <CartProvider>
                  <InitPage>
                    <ScrollToTop />
                    <Routes>
                      <Route path="/" element={<HomePage />} />
                      <Route path="/unavailable" element={<ServiceUnavailablePage />} />
                      <Route path="/menu" element={<MenuPage />} />
                      <Route path="/bill" element={<BillPage />} />
                      <Route path="/checkout" element={<CheckoutPage />} />
                      <Route path="/checkout-tips" element={<CheckoutTipsPage />} />
                      <Route path="/payment" element={<PaymentPage />} />
                      <Route path="/cart" element={<CartPage />} />
                      <Route path="/orders" element={<OrdersPage />} />
                      <Route path="/order/:orderId" element={<OrderPage />} />
                      <Route path="/:slug" element={<RestaurantSelectPage />} />
                      <Route path="/:slug/:restaurantSlug" element={<MenuDeliveryPage />} />
                      <Route
                        path="/:slug/:restaurantSlug/checkout"
                        element={<CheckoutDeliveryPage />}
                      />
                      <Route
                        path="/:slug/:restaurantSlug/payment"
                        element={<PaymentDeliveryPage />}
                      />
                      <Route path="*" element={<NotFoundPage />} />
                    </Routes>
                  </InitPage>
                </CartProvider>
              </CheckoutProvider>
            </RestaurantProvider>
          </DeliveryProvider>
        </AuthProvider>
      </AlertProvider>
    </SettingsProvider>
  );
};

export default App;
